import { render, staticRenderFns } from "./ClipboardHistory.vue?vue&type=template&id=95021436&scoped=true"
import script from "./ClipboardHistory.vue?vue&type=script&lang=js"
export * from "./ClipboardHistory.vue?vue&type=script&lang=js"
import style0 from "./ClipboardHistory.vue?vue&type=style&index=0&id=95021436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95021436",
  null
  
)

export default component.exports